import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function Articles() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '黄油知识' }]} />

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-3">
                黄油知识库
              </h1>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
                学习黄油选购、使用和保存的专业知识，成为黄油达人
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '在线黄油 - 黄油知识库',
            description: '学习黄油选购、使用和保存的专业知识，了解发酵黄油、无盐黄油、动物黄油等各类黄油的特点和用法。',
            url: 'https://wlsmfl.cn/articles',
            isPartOf: {
              '@type': 'WebSite',
              name: '在线黄油',
              url: 'https://wlsmfl.cn',
            },
          }),
        }}
      />
    </>
  );
}